import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type ParamsType = {
  roomId: string
}

// 直播間的相關資料，例如 kol 名稱、觀看數、跑馬燈或公告等
class FetchRoomProductDataApi extends Service {
  constructor({ roomId }: ParamsType) {
    super()
    this.name = 'FETCH_ROOM_PRODUCT_DATA'

    this.config = {
      url: `/v1/product/room/${roomId}`,
      method: 'GET',
    }
  }
}

export const fetchRoomProductData = (params: ParamsType) => getCallApiFunction(new FetchRoomProductDataApi(params))
